<template>
  <div class="home5-container">
    <div class="nav1">
      <div class="left">
        <div class="item tran-all"
          :class="[index==index1?'active':'',index!==index1&&(index+1)!=index1?'has-border':'']"
          @click="clickFirst(index,0)" v-for="(item,index) in navigation" :key="index">{{item.name}}
        </div>
      </div>
      <div class="right">
        <div>
          <span class="zsf-icon zsf-icon-touxiang"></span>
          <span class="ml-3">张三丰</span>
        </div>
        <div @click="quit" class="c-pointer">
          <span class="zsf-icon zsf-icon-tuichu"></span>
          <span class="ml-3">退出</span>
        </div>
      </div>
    </div>
    <div class="nav2">
      <div class="left">
        <div class="item tran-all" :class="index==index2?'active':''" @click="clickSecond(index)"
          v-for="(item,index) in navigation[index1].child" :key="index">
          <span>{{item.name}}</span>
        </div>
      </div>
      <div class="right">
        <div class="search">
          <el-input type="primary" placeholder="搜索人员查看位置" v-model="person" class="input"
            size="mini">
            <el-button type="primary" style="padding:12px;" slot="append" @click="search"
              icon="el-icon-search"></el-button>
          </el-input>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="box-left">
        <div class="charts-box charts-1">
          <div class="title">
            <span class="zsf-icon zsf-icon-touxiang"></span>
            <span>人员总数</span>
          </div>
          <div id="left-echarts" style="width:400px;height:220px;"></div>
        </div>
        <div class="charts-box charts-2">
          <div class="title">
            <span class="zsf-icon zsf-icon-shebei"></span>
            <span>报警总数</span>
          </div>
          <div id="left-echarts2" style="width:400px;height:220px;"></div>
        </div>
      </div>
      <div class="box-right">
        <div class="map-box">
          <img src="../../common/images/ship.png" style="max-height:505px;" />
        </div>
        <div class="controls">
          <div class="item">
            <span class="zsf-icon zsf-icon-fangda"></span>
          </div>
          <div class="item">
            <span class="zsf-icon zsf-icon-suoxiao"></span>
          </div>
          <div class="item">
            <span class="zsf-icon zsf-icon-dingwei"></span>
          </div>
          <div class="item">
            <span class="zsf-icon zsf-icon-luxiang"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <img style="width:300px" src="../../common/images/logo.png" />
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { navigation } from "../../config.js";
import { tool } from "../../common/js/tool.js";
export default {
  data() {
    return {
      navigation: navigation,
      index1: 0,
      index2: 0,
      myChart3: null,
      myChart3Data: [],
      count1: 0,
      myChart4: null,
      myChart4Data: [],
      count2: 0,
      person: ""
    };
  },

  computed: {},

  created() {},

  mounted() {
    this.myChart3Data = [
      { name: "铆工", value: tool.mathRandom(10, 100) },
      { name: "电焊工", value: tool.mathRandom(10, 100) },
      { name: "涂漆工", value: tool.mathRandom(10, 100) },
      { name: "吊车工", value: tool.mathRandom(10, 100) },
      { name: "切割工", value: tool.mathRandom(10, 100) }
    ];
    let count1 = 0;
    for (let i = 0; i < this.myChart3Data.length; i++) {
      count1 += this.myChart3Data[i].value;
    }
    this.count1 = count1;
    this.leftEcharts();
    this.myChart4Data = [
      { name: "铆工", value: tool.mathRandom(1, 20) },
      { name: "电焊工", value: tool.mathRandom(1, 20) },
      { name: "涂漆工", value: tool.mathRandom(1, 20) },
      { name: "吊车工", value: tool.mathRandom(1, 20) },
      { name: "切割工", value: tool.mathRandom(1, 20) }
    ];
    let count2 = 0;
    for (let i = 0; i < this.myChart4Data.length; i++) {
      count2 += this.myChart4Data[i].value;
    }
    this.count2 = count2;
    this.leftEcharts2();
  },

  methods: {
    search() {
      if (this.person) {
        alert(this.person);
      } else {
        alert("请输入内容");
      }
    },
    leftEcharts() {
      var dom = document.getElementById("left-echarts");
      if (
        this.myChart3 !== null &&
        this.myChart3 !== "" &&
        this.myChart3 !== undefined
      ) {
        this.myChart3.dispose();
      }
      this.myChart3 = this.$echarts.init(dom);
      var option = {
        title: {
          zlevel: 0,
          text: this.count1,
          top: "center",
          left: "195",
          textAlign: "center"
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: ["32%", "55%"],
            label: {
              formatter: "  {b|{b}：}{c}  ",
              backgroundColor: "#eee",
              borderColor: "#aaa",
              rich: {
                a: {
                  color: "#999",
                  lineHeight: 22,
                  align: "center"
                },
                hr: {
                  borderColor: "#aaa",
                  width: "100%",
                  borderWidth: 0.5,
                  height: 0
                },
                b: {
                  fontSize: 12,
                  lineHeight: 25
                },
                per: {
                  color: "#eee",
                  backgroundColor: "#334455",
                  padding: [2, 4],
                  borderRadius: 2
                }
              }
            },
            data: this.myChart3Data
          }
        ]
      };
      if (option && typeof option === "object") {
        this.myChart3.setOption(option, true);
      }
    },
    leftEcharts2() {
      var dom = document.getElementById("left-echarts2");
      if (
        this.myChart4 !== null &&
        this.myChart4 !== "" &&
        this.myChart4 !== undefined
      ) {
        this.myChart4.dispose();
      }
      this.myChart4 = this.$echarts.init(dom);
      var option = {
        title: {
          zlevel: 0,
          text: this.count2,
          top: "center",
          left: "195",
          textAlign: "center"
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: ["32%", "55%"],
            label: {
              formatter: "  {b|{b}：}{c}  ",
              backgroundColor: "#eee",
              borderColor: "#aaa",
              rich: {
                a: {
                  color: "#999",
                  lineHeight: 22,
                  align: "center"
                },
                hr: {
                  borderColor: "#aaa",
                  width: "100%",
                  borderWidth: 0.5,
                  height: 0
                },
                b: {
                  fontSize: 12,
                  lineHeight: 25
                },
                per: {
                  color: "#eee",
                  backgroundColor: "#334455",
                  padding: [2, 4],
                  borderRadius: 2
                }
              }
            },
            data: this.myChart4Data
          }
        ]
      };
      if (option && typeof option === "object") {
        this.myChart4.setOption(option, true);
      }
    },
    clickFirst(index1, index2) {
      this.index1 = index1;
      this.index2 = index2;
    },
    clickSecond(index) {
      this.index2 = index;
    },
    quit() {
      this.$confirm("确定要退出吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$router.push({ path: "/login" });
      });
    }
  },

  components: {}
};
</script>

<style lang="less" rel="stylesheet/less">
@import url("../../common/less/variable.less");

.home5-container {
  width: 100%;
  height: 100%;
  background: #e6e8ef;
  padding: 15px;
  overflow-y: auto;
  .nav1 {
    display: flex;
    height: 44px;
    align-items: stretch;
    .left {
      flex: 1;
      display: flex;
      align-items: stretch;
      .item {
        color: #70789d;
        width: 105px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        cursor: pointer;
        font-size: 16px;
        &:hover {
          color: #30417a;
          font-weight: 600;
        }
        &.active {
          background: linear-gradient(
            360deg,
            rgba(39, 60, 158, 1) 0%,
            rgba(51, 72, 169, 1) 100%
          );
          border-radius: 10px 10px 0 0;
          color: white;
          font-weight: 600;
          &:before {
            background: none;
          }
        }
        &.has-border {
          &:before {
            display: block;
            content: "";
            width: 1px;
            height: 20px;
            position: absolute;
            right: 0;
            top: 12px;
            background: #70789d;
          }
        }
        &:last-child {
          &:before {
            background: none;
          }
        }
      }
    }
    .right {
      display: flex;
      justify-content: center;
      color: #3b3b3b;
      align-items: stretch;
      font-size: 12px;
      div {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
      }
    }
  }
  .nav2 {
    width: 100%;
    height: 36px;
    background: #21409d;
    border-radius: 0 10px 0 0;
    padding: 0 15px 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    .left {
      display: flex;
      align-items: stretch;
      height: 36px;
      .item {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.8);
        float: left;
        margin-right: 10px;
        display: flex;
        align-items: center;
        cursor: pointer;
        span {
          height: 14px;
          border-right: 1px solid rgba(255, 255, 255, 0.8);
          padding-right: 10px;
        }
        &:last-child {
          span {
            border-right: none;
          }
        }
        &:hover,
        &.active {
          color: white;
          span {
            font-weight: bold;
          }
        }
      }
    }
    .right {
      display: flex;
      align-items: center;
      justify-content: center;
      .search {
        /*position: absolute;*/
        z-index: 10;
        /*left: 15px;*/
        /*top: 15px;*/
        .input {
          width: 200px;
          .el-input__inner {
            padding: 0 10px;
          }
        }
      }
    }
  }
  .box {
    width: 100%;
    height: auto;
    background: rgba(247, 247, 247, 1);
    box-shadow: 0px -5px 19px 0px rgba(155, 168, 227, 0.24);
    border-radius: 0 0 10px 10px;
    display: flex;
    align-items: stretch;
    padding: 15px;
    .box-left {
      width: 400px;
      margin-right: 15px;
      height: auto;
      background: #e6e8ef;
      border-radius: 4px;
      border: 1px solid rgba(230, 230, 230, 1);
      .charts-box {
        width: 400px;
        height: 260px;
        padding-top: 30px;
        .title {
          text-align: center;
          color: #30417a;
          span {
            font-size: 17px;
          }
          .zsf-icon {
            font-size: 17px;
            margin-right: 3px;
          }
        }
        &.charts-1 {
          .charts-left {
            background: linear-gradient(
              135deg,
              rgba(39, 60, 158, 1) 0%,
              rgba(92, 112, 207, 1) 100%,
              rgba(93, 113, 208, 1) 100%
            );
          }
        }
        &.charts-2 {
          .charts-left {
            background: linear-gradient(
              135deg,
              rgba(202, 59, 59, 1) 0%,
              rgba(255, 133, 37, 1) 100%,
              rgba(93, 113, 208, 1) 100%
            );
            &:after {
              border-left: 10px solid #e8683b;
            }
            .count {
              &:before {
                background: rgba(251, 116, 82, 1);
              }
            }
          }
        }
      }
    }
    .box-right {
      width: 0;
      flex: 1;
      height: 535px;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(230, 230, 230, 1);
      padding: 15px;
      position: relative;
      .map-box {
        width: 100%;
        height: 505px;
        overflow: hidden;
      }
      .controls {
        display: flex;
        position: absolute;
        right: 15px;
        bottom: 15px;
        z-index: 10;
        .item {
          margin-left: 12px;
          width: 32px;
          height: 32px;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0 2px 6px 0 rgba(51, 72, 169, 0.31);
          border-radius: 2px;
          display: flex;
          justify-content: center;
          align-items: center;
          transition: all 0.2s ease;
          cursor: pointer;
          &:hover {
            transform: scale(1.1);
          }
          span {
            transition: all 0.2s ease;
            font-size: 20px;
            color: #3348a9;
            display: inline-block;
          }
        }
      }
    }
  }
  .footer {
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
